export const list = {
  job_number: {
    name: '工号',
    key: 'job_number'
  },
  realname: {
    name: '姓名',
    key: 'realname'
  },
  completed_number_of_tasks: {
    name: '任务完成进度',
    key: 'completed_number_of_tasks',
    width: 230
  },
  total_number_of_projects: {
    name: '当前参与项目',
    key: 'total_number_of_projects',
    sortable: true,
  },
  undone_number_of_tasks_sum_working_day: {
    name: '剩余任务工时（天）',
    key: 'undone_number_of_tasks_sum_working_day',
    sortable: true,
    width: 200,
  },
  undone_number_of_tasks_avg_working_day: {
    name: '剩余任务平均工时（天）',
    key: 'undone_number_of_tasks_avg_working_day',
    sortable: true,
    width: 220
  },
  projects_with_the_most_undone_tasks: {
    name: '剩余任务最多项目',
    key: 'projects_with_the_most_undone_tasks.title',
    width: 200,
    check: true
  },
  projects_with_the_most_completed_tasks: {
    name: '已完成任务最多项目',
    key: 'projects_with_the_most_completed_tasks.title',
    check: true
  },
};
